import React, {useState, useEffect} from 'react';
import {Table} from "antd";
import {CONSTANTS} from "../utils/constant";

export default function CompoundTable({tableName, record, isProperty, pdb, folder}) {
    const [data, setData] = useState([]);

    const propertyColumns = [{title: 'Property', dataIndex: 1, key: 0},
        {title: 'Value', dataIndex: 2, key: 0}];

    //Res. Name 1,Res. Number 1,Chain 1,Complex ASA,Free ASA,Buried ASA (Interface),Buried ASA %
    const dataColumns = [{title: 'Res. Name 1', dataIndex: 1, key: 0, sorter: (a, b) => a[1].localeCompare(b[1])},
        {title: 'Res. Number 1', dataIndex: 2, key: 0, sorter: (a, b) => a[2] - b[2]},
        {title: 'Chain 1', dataIndex: 3, key: 0},
        {title: 'Complex ASA', dataIndex: 4, key: 0, sorter: (a, b) => a[4] - b[4]},
        {title: 'Free ASA', dataIndex: 5, key: 0, sorter: (a, b) => a[5] - b[5]},
        {title: 'Buried ASA (Interface)', dataIndex: 6, key: 0, sorter: (a, b) => a[6] - b[6]},
        {title: 'Buried ASA %', dataIndex: 7, key: 0, sorter: (a, b) => a[7] - b[7]}];

    useEffect(() => {

        const csvToData = (csv) => {
            let data = [];
            let rows = csv.split("\n");
            rows.forEach(row => {
                if (row)
                    data.push(row.split(","));
            });
            return data;
        }

        const callService = async () => {

            const postData = new FormData();
            postData.append("tableName", tableName);
            postData.append("folder", folder);
            postData.append("pdb", pdb);
            postData.append("chain1", record[3]);
            postData.append("chain2", record[6]);

            try {
                const response = await fetch(CONSTANTS.PHP_SCRIPT_BASE_PATH + 'get_table.php', {
                    method: 'POST',
                    body: postData
                });

                const result = await response.json();
                const parsedData = csvToData(result.data);
                parsedData.shift();
                setData(parsedData);

            } catch (error) {
                console.error('Errore durante la richiesta:', error);
            }
        };

        callService();
    }, [tableName])

    return (
        <>
            <Table size={"small"} rowKey={0} dataSource={data} columns={isProperty ? propertyColumns : dataColumns} showHeader={!isProperty} pagination={false}/>
        </>
    )
}